package com.patronat.top.client.presentation.home

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.client.presentation.home.components.AllCategoriesContent
import com.patronat.top.client.presentation.home.components.ClientVenueFilterContent
import com.patronat.top.client.presentation.home.components.HomeCategorySection
import com.patronat.top.client.presentation.home.components.HomeHeader
import com.patronat.top.client.presentation.home.components.HomeSearchRow
import com.patronat.top.client.presentation.home.components.HomeSectionHeader
import com.patronat.top.client.presentation.home.components.HomeVenueEmptyState
import com.patronat.top.client.presentation.home.components.LocationSearchContent
import com.patronat.top.client.presentation.home.components.VenueDetailsDesktopContent
import com.patronat.top.client.presentation.home.components.VenueDetailsContent
import com.patronat.top.client.presentation.home.components.VenueListCard
import com.patronat.top.client.presentation.home.components.VenueReviewContent
import com.patronat.top.client.presentation.home.components.VenueReviewsDesktopContent
import com.patronat.top.client.presentation.home.components.VenueReviewsContent
import com.patronat.top.client.presentation.home.components.VenueServicesCatalogContent
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.molecules.branding.AppLogo
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.AppImages
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.MineShaft400
import com.patronat.top.ui.theme.MineShaft600
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.White
import com.patronat.top.dto.VenueResponse
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.client_home_location_city
import top.clientapp.generated.resources.client_web_install_button
import top.clientapp.generated.resources.client_web_install_description
import top.clientapp.generated.resources.client_web_install_title

@Composable
fun ClientHomeContent(
    state: ClientHomeViewState,
    onEvent: (ClientHomeEvent) -> Unit,
    webMode: Boolean = false,
    modifier: Modifier = Modifier
) {
    var showInstallPrompt by remember { mutableStateOf(false) }
    val showInstallPromptAction = { showInstallPrompt = true }

    BoxWithConstraints(
        modifier = modifier
            .fillMaxSize()
            .background(White)
    ) {
        val isWideWeb = webMode && maxWidth >= 900.dp

        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.TopCenter
        ) {
            if (isWideWeb && state.currentScreen == ClientHomeScreen.Feed) {
                ClientHomeDesktopContent(
                    state = state,
                    onEvent = onEvent,
                    onInstallRequired = showInstallPromptAction,
                    modifier = Modifier.fillMaxSize()
                )
            } else if (isWideWeb && state.currentScreen == ClientHomeScreen.VenueDetails) {
                val venue = state.selectedVenue()
                if (venue != null) {
                    VenueDetailsDesktopContent(
                        venue = venue,
                        isFavorite = venue.id in state.favoriteVenueIds,
                        onBackClick = { onEvent(ClientHomeEvent.OnVenueDetailsBackClicked) },
                        onFavoriteClick = showInstallPromptAction,
                        onCatalogClick = { onEvent(ClientHomeEvent.OnVenueCatalogClicked) },
                        onViewReviewsClick = { onEvent(ClientHomeEvent.OnVenueReviewsClicked) },
                        onReviewClick = showInstallPromptAction,
                        modifier = Modifier.fillMaxSize()
                    )
                } else {
                    ClientHomeMobileContent(
                        state = state,
                        onEvent = onEvent,
                        webMode = webMode,
                        onInstallRequired = showInstallPromptAction,
                        modifier = Modifier
                            .fillMaxSize()
                            .widthIn(max = 430.dp)
                    )
                }
            } else if (isWideWeb && state.currentScreen == ClientHomeScreen.VenueReviews) {
                val venue = state.selectedVenue()
                if (venue != null) {
                    VenueReviewsDesktopContent(
                        venue = venue,
                        reviews = state.venueReviews,
                        summary = state.venueReviewSummary,
                        isLoading = state.isVenueReviewsLoading,
                        selectedPhotoUrl = state.selectedReviewPhotoUrl,
                        likingReviewIds = state.likingReviewIds,
                        isFavorite = venue.id in state.favoriteVenueIds,
                        onBackClick = { onEvent(ClientHomeEvent.OnVenueReviewsBackClicked) },
                        onReviewClick = showInstallPromptAction,
                        onFavoriteClick = showInstallPromptAction,
                        onPhotoClick = { onEvent(ClientHomeEvent.OnVenueReviewPhotoClicked(it)) },
                        onPhotoDismiss = { onEvent(ClientHomeEvent.OnVenueReviewPhotoDismissed) },
                        onLikeClick = { showInstallPromptAction() },
                        modifier = Modifier.fillMaxSize()
                    )
                } else {
                    ClientHomeMobileContent(
                        state = state,
                        onEvent = onEvent,
                        webMode = webMode,
                        onInstallRequired = showInstallPromptAction,
                        modifier = Modifier
                            .fillMaxSize()
                            .widthIn(max = 430.dp)
                    )
                }
            } else {
                ClientHomeMobileContent(
                    state = state,
                    onEvent = onEvent,
                    webMode = webMode,
                    onInstallRequired = showInstallPromptAction,
                    modifier = if (isWideWeb) {
                        Modifier
                            .fillMaxSize()
                            .widthIn(max = 430.dp)
                    } else {
                        Modifier.fillMaxSize()
                    }
                )
            }
        }

        if (isWideWeb) {
            AppLogo(
                iconSize = 40,
                fontSize = 28,
                modifier = Modifier
                    .align(Alignment.TopStart)
                    .padding(start = 30.dp, top = 26.dp)
            )
        }

        if (showInstallPrompt) {
            WebInstallAppDialog(
                onDismiss = { showInstallPrompt = false },
                onInstallClick = { showInstallPrompt = false }
            )
        }
    }
}

@Composable
private fun ClientHomeMobileContent(
    state: ClientHomeViewState,
    onEvent: (ClientHomeEvent) -> Unit,
    webMode: Boolean,
    onInstallRequired: () -> Unit,
    modifier: Modifier = Modifier
) {
    if (state.currentScreen == ClientHomeScreen.VenueDetails) {
        val venue = state.selectedVenue()
        if (venue != null) {
            VenueDetailsContent(
                venue = venue,
                isFavorite = venue.id in state.favoriteVenueIds,
                onBackClick = { onEvent(ClientHomeEvent.OnVenueDetailsBackClicked) },
                onFavoriteClick = {
                    if (webMode) onInstallRequired() else onEvent(ClientHomeEvent.OnFavoriteClicked(venue.id))
                },
                onCatalogClick = { onEvent(ClientHomeEvent.OnVenueCatalogClicked) },
                onViewReviewsClick = { onEvent(ClientHomeEvent.OnVenueReviewsClicked) },
                onReviewClick = {
                    if (webMode) onInstallRequired() else onEvent(ClientHomeEvent.OnVenueReviewClicked)
                },
                modifier = modifier
            )
            return
        }
    }

    if (state.currentScreen == ClientHomeScreen.VenueServices) {
        val venue = state.selectedVenue()
        if (venue != null) {
            VenueServicesCatalogContent(
                venue = venue,
                onBackClick = { onEvent(ClientHomeEvent.OnVenueCatalogBackClicked) },
                modifier = modifier
            )
            return
        }
    }

    if (state.currentScreen == ClientHomeScreen.VenueReviews) {
        val venue = state.selectedVenue()
        if (venue != null) {
            VenueReviewsContent(
                venue = venue,
                reviews = state.venueReviews,
                summary = state.venueReviewSummary,
                isLoading = state.isVenueReviewsLoading,
                selectedPhotoUrl = state.selectedReviewPhotoUrl,
                likingReviewIds = state.likingReviewIds,
                onBackClick = { onEvent(ClientHomeEvent.OnVenueReviewsBackClicked) },
                onPhotoClick = { onEvent(ClientHomeEvent.OnVenueReviewPhotoClicked(it)) },
                onPhotoDismiss = { onEvent(ClientHomeEvent.OnVenueReviewPhotoDismissed) },
                onLikeClick = {
                    if (webMode) onInstallRequired() else onEvent(ClientHomeEvent.OnVenueReviewLikeClicked(it))
                },
                modifier = modifier
            )
            return
        }
    }

    if (state.currentScreen == ClientHomeScreen.VenueReview) {
        val venue = state.selectedVenue()
        if (venue != null) {
            VenueReviewContent(
                venue = venue,
                form = state.reviewForm,
                isFavorite = venue.id in state.favoriteVenueIds,
                onBackClick = { onEvent(ClientHomeEvent.OnVenueReviewBackClicked) },
                onFavoriteClick = {
                    if (webMode) onInstallRequired() else onEvent(ClientHomeEvent.OnFavoriteClicked(venue.id))
                },
                onOverallRatingChange = { onEvent(ClientHomeEvent.OnReviewOverallRatingChanged(it)) },
                onDetailRatingChange = { metric, value ->
                    onEvent(ClientHomeEvent.OnReviewDetailRatingChanged(metric, value))
                },
                onTextChange = { onEvent(ClientHomeEvent.OnReviewTextChanged(it)) },
                onAddPhotoClick = { onEvent(ClientHomeEvent.OnReviewPhotoAddClicked) },
                onRemovePhotoClick = { onEvent(ClientHomeEvent.OnReviewPhotoRemoved(it)) },
                onSubmitClick = { onEvent(ClientHomeEvent.OnSubmitReviewClicked) },
                modifier = modifier
            )
            return
        }
    }

    if (state.currentScreen == ClientHomeScreen.AllCategories) {
        AllCategoriesContent(
            searchQuery = state.categorySearchQuery,
            expandedGroups = state.expandedCategoryGroups,
            onBackClick = { onEvent(ClientHomeEvent.OnBackToHomeClicked) },
            onSearchQueryChange = { onEvent(ClientHomeEvent.OnCategorySearchChanged(it)) },
            onGroupClick = { onEvent(ClientHomeEvent.OnCategoryGroupClicked(it)) },
            onCategoryClick = { onEvent(ClientHomeEvent.OnVenueCategoryClicked(it)) },
            modifier = modifier
        )
        return
    }

    if (state.currentScreen == ClientHomeScreen.LocationSearch) {
        LocationSearchContent(
            query = state.locationSearchQuery,
            suggestions = state.locationSuggestions,
            isLoading = state.isLocationSearchLoading,
            onBackClick = { onEvent(ClientHomeEvent.OnCloseLocationSearchClicked) },
            onQueryChange = { onEvent(ClientHomeEvent.OnLocationSearchChanged(it)) },
            onSuggestionClick = { onEvent(ClientHomeEvent.OnLocationSuggestionClicked(it)) },
            modifier = modifier
        )
        return
    }

    if (state.currentScreen == ClientHomeScreen.Filters) {
        ClientVenueFilterContent(
            locationFilter = state.filterLocation,
            serviceSearchQuery = state.serviceSearchQuery,
            serviceSuggestions = state.serviceSuggestions,
            selectedServiceQueries = state.selectedServiceQueries,
            priceBounds = state.filterPriceBounds,
            priceRange = state.filterPriceRange,
            ratingRange = state.filterRatingRange,
            onLocationClick = { onEvent(ClientHomeEvent.OnFilterLocationClicked(it)) },
            onServiceSearchChange = { onEvent(ClientHomeEvent.OnServiceSearchChanged(it)) },
            onServiceSuggestionClick = { onEvent(ClientHomeEvent.OnServiceSuggestionClicked(it)) },
            onSelectedServiceRemove = { onEvent(ClientHomeEvent.OnSelectedServiceRemoved(it)) },
            onPriceRangeChange = { onEvent(ClientHomeEvent.OnFilterPriceRangeChanged(it)) },
            onRatingRangeChange = { onEvent(ClientHomeEvent.OnFilterRatingRangeChanged(it)) },
            onBackClick = { onEvent(ClientHomeEvent.OnCloseFiltersClicked) },
            onApplyClick = { onEvent(ClientHomeEvent.OnApplyFiltersClicked) },
            modifier = modifier
        )
        return
    }

    ClientHomeFeedContent(
        state = state,
        onEvent = onEvent,
        webMode = webMode,
        onInstallRequired = onInstallRequired,
        modifier = modifier
    )
}

@Composable
private fun ClientHomeFeedContent(
    state: ClientHomeViewState,
    onEvent: (ClientHomeEvent) -> Unit,
    webMode: Boolean,
    onInstallRequired: () -> Unit,
    modifier: Modifier = Modifier
) {
    LazyColumn(
        modifier = modifier
            .fillMaxSize()
            .background(White),
        contentPadding = PaddingValues(start = 24.dp, top = 16.dp, end = 24.dp, bottom = 18.dp),
        verticalArrangement = Arrangement.spacedBy(20.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        item {
            val fallbackLocation = stringResource(Res.string.client_home_location_city)
            HomeHeader(
                locationTitle = state.currentLocationTitle?.takeIf(String::isNotBlank) ?: fallbackLocation,
                onLocationClick = { onEvent(ClientHomeEvent.OnLocationSelectorClicked) },
                modifier = Modifier.fillMaxWidth()
            )
        }

        item {
            HomeSearchRow(
                value = state.searchQuery,
                onValueChange = { onEvent(ClientHomeEvent.OnSearchChanged(it)) },
                onFilterClick = {
                    if (webMode) onInstallRequired() else onEvent(ClientHomeEvent.OnFilterClicked)
                },
                modifier = Modifier.fillMaxWidth()
            )
        }

        item {
            HomeCategorySection(
                selectedGroup = state.selectedGroup,
                onCategoryClick = { onEvent(ClientHomeEvent.OnHomeCategoryClicked(it)) },
                onViewAllClick = {
                    if (webMode) onInstallRequired() else onEvent(ClientHomeEvent.OnViewAllCategoriesClicked)
                },
                modifier = Modifier.fillMaxWidth()
            )
        }

        item {
            HomeSectionHeader(
                title = ClientHomeVenuesTitle,
                modifier = Modifier.fillMaxWidth()
            )
        }

        if (state.isLoading && state.venues.isEmpty()) {
            item {
                CircularProgressIndicator(
                    color = Primary600,
                    modifier = Modifier.padding(top = 24.dp)
                )
            }
        } else if (state.venues.isEmpty()) {
            item {
                HomeVenueEmptyState(modifier = Modifier.fillMaxWidth())
            }
        } else {
            items(
                items = state.venues,
                key = { it.id }
            ) { venue ->
                VenueListCard(
                    venue = venue,
                    isFavorite = venue.id in state.favoriteVenueIds,
                    onClick = { onEvent(ClientHomeEvent.OnVenueClicked(venue.id)) },
                    onFavoriteClick = {
                        if (webMode) onInstallRequired() else onEvent(ClientHomeEvent.OnFavoriteClicked(venue.id))
                    },
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}

private const val ClientHomeVenuesTitle = "Заклади"

private fun ClientHomeViewState.selectedVenue(): VenueResponse? {
    val venueId = selectedVenueId ?: return null
    return allVenues.firstOrNull { it.id == venueId } ?: venues.firstOrNull { it.id == venueId }
}

@Composable
private fun WebInstallAppDialog(
    onDismiss: () -> Unit,
    onInstallClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.28f))
            .clickable(onClick = onDismiss),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .widthIn(max = 360.dp)
                .fillMaxWidth()
                .padding(horizontal = 24.dp)
                .clip(RoundedCornerShape(18.dp))
                .background(White)
                .clickable(onClick = {})
                .padding(20.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Box(
                modifier = Modifier.fillMaxWidth()
            ) {
                Box(
                    modifier = Modifier
                        .align(Alignment.TopEnd)
                        .size(28.dp)
                        .clip(CircleShape)
                        .clickable(onClick = onDismiss),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = AppIcons.Close,
                        contentDescription = null,
                        tint = MineShaft400,
                        modifier = Modifier.size(16.dp)
                    )
                }
            }

            Image(
                painter = painterResource(AppImages.OnboardingReviews),
                contentDescription = null,
                contentScale = ContentScale.Crop,
                modifier = Modifier
                    .size(132.dp)
                    .clip(CircleShape)
            )

            androidx.compose.foundation.layout.Spacer(modifier = Modifier.height(18.dp))

            Text(
                text = stringResource(Res.string.client_web_install_title),
                style = BodyMedium.copy(
                    color = MineShaft950,
                    fontSize = 28.sp,
                    lineHeight = 36.sp,
                    fontWeight = FontWeight.Medium,
                    textAlign = TextAlign.Center,
                    letterSpacing = (-0.12).sp
                )
            )

            androidx.compose.foundation.layout.Spacer(modifier = Modifier.height(10.dp))

            Text(
                text = stringResource(Res.string.client_web_install_description),
                style = BodyMedium.copy(
                    color = MineShaft600,
                    fontSize = 15.sp,
                    lineHeight = 24.sp,
                    fontWeight = FontWeight.Normal,
                    textAlign = TextAlign.Center
                )
            )

            androidx.compose.foundation.layout.Spacer(modifier = Modifier.height(22.dp))

            AppButton(
                text = stringResource(Res.string.client_web_install_button),
                onClick = onInstallClick,
                type = ButtonType.Black,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}
